import React from 'react';
import { CheckIcon, XMarkIcon, ArrowRightIcon, EyeIcon, ArrowUturnLeftIcon } from '@heroicons/react/24/solid';
import ChoiceButton from './ChoiceButton';

const SimpleAnswerSection = ({ showResultCard, onReveal, onChoice, userChoice, isIgnored, onNext }) => {
  const hasMadeChoice = userChoice !== null;

  return (
    <div className="flex flex-col items-center gap-4 w-full max-w-sm mx-auto">
      {/* --- Top Section: Holds either the Choice Dock or the Ignored Message --- */}
      <div className="relative w-full h-[62px] flex items-center justify-center">

        {/* Main Choice Dock */}
        <div className="w-full inline-flex items-center gap-2 p-1.5 bg-background-secondary rounded-full border border-border shadow-md">
          {!showResultCard ? (
            <button
              onClick={onReveal}
              className="flex-1 w-full flex items-center justify-center gap-2 px-8 py-3 bg-secondary text-white font-semibold rounded-full shadow-md hover:bg-secondary/90 transition-colors"
            >
              <EyeIcon className="h-5 w-5" />
              Reveal Answer
            </button>
          ) : (
            <>
              {isIgnored ? (
                <>
                  <div className="flex-1 flex items-center justify-center gap-2 px-4 py-3 bg-background-tertiary rounded-full">
                    <ArrowUturnLeftIcon className="h-5 w-5 text-yellow-500" />
                    <span className="font-semibold text-yellow-500">Answer Ignored</span>
                  </div>
                  <button
                    onClick={onNext}
                    className="flex items-center justify-center gap-2 px-6 py-3 bg-primary text-white font-semibold rounded-full shadow-md hover:bg-primary/90 transition-colors"
                  >
                    <ArrowRightIcon className="h-5 w-5" />
                    Next
                  </button>
                </>
              ) : !hasMadeChoice ? (
                <>
                  <ChoiceButton
                    text="Correct"
                    icon={CheckIcon}
                    onClick={() => onChoice(true)}
                    isSelected={userChoice === true}
                    disabled={hasMadeChoice}
                    color="green"
                  />
                  <ChoiceButton
                    text="Incorrect"
                    icon={XMarkIcon}
                    onClick={() => onChoice(false)}
                    isSelected={userChoice === false}
                    disabled={hasMadeChoice}
                    color="red"
                  />
                </>
              ) : (
                <>
                  <div className="flex-1 flex items-center justify-center gap-2 px-4 py-3 bg-background-tertiary rounded-full">
                    {userChoice ? (
                      <>
                        <CheckIcon className="h-5 w-5 text-green-600" />
                        <span className="font-semibold text-green-700 dark:text-green-400">Correct</span>
                      </>
                    ) : (
                      <>
                        <XMarkIcon className="h-5 w-5 text-red-600" />
                        <span className="font-semibold text-red-700 dark:text-red-400">Incorrect</span>
                      </>
                    )}
                  </div>
                  <button
                    onClick={onNext}
                    className="flex items-center justify-center gap-2 px-6 py-3 bg-primary text-white font-semibold rounded-full shadow-md hover:bg-primary/90 transition-colors"
                  >
                    <ArrowRightIcon className="h-5 w-5" />
                    Next
                  </button>
                </>
              )}
            </>
          )}
        </div>
      </div>

    </div>
  );
};

export default SimpleAnswerSection;
